import React, { Component } from 'react';
import { Link } from 'react-router';

import EmailSignupForm from '../../Forms/EmailSignupForm';

export default class EmailSignup extends Component {

  render() {
    const { } = this.props;

    return (
      <div className="EmailSignup">
 				<h2>Subscribe to the Moose Almighty newsletter and get 10% off all merchandise</h2>
 				<p>Enter your email address and we'll send you a special promo code for <span class="bold">10% off all Moose Almighty merchandise</span> on our <Link to="/store" target="_blank">online store</Link>. You'll also recieve all the latest news, updates and show announcements.</p>
 				<EmailSignupForm />
      </div>    
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Sections/EmailSignup/EmailSignup.js